import { render, staticRenderFns } from "./taskType.vue?vue&type=template&id=cc76c328&scoped=true"
import script from "./taskType.vue?vue&type=script&lang=js"
export * from "./taskType.vue?vue&type=script&lang=js"
import style0 from "./taskType.vue?vue&type=style&index=0&id=cc76c328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc76c328",
  null
  
)

export default component.exports